<template>
  <div class="ws-info-checkbox">
    <div v-if="_content">
      <div
        v-for="(item, index) in _content"
        :key="index"
      >{{item}}</div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    $_getItemsByValue(value) {
      let _items = [];
      this.items.forEach((item) => {
        let index = 0;
        item.value.forEach((valueItem) => {
          if (index >= 0) {
            index = value.findIndex((findItem) => findItem === valueItem);
          }
        });
        if (index >= 0) {
          _items.push(item.text);
        }
      });
      return _items;
    },
  },
  computed: {
    _content() {
      if (this.value == undefined || !this.items.length) {
        return null;
      } else {
        return this.$_getItemsByValue(this.value);
      }
    },
  },
  props: {
    value: {
      type: [Number, String, Array],
      default: null,
    },
    items: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style>
</style>